import { Context, useContext } from 'react';
import { ModuleContext, ModuleContextType } from '../context/ModuleContext';

export const useModule = <T>() => {
    return useContext<ModuleContextType<T>>(ModuleContext as Context<ModuleContextType<T>>);
};
